export default "__VITE_ASSET__Blsgn0Dy__"